import { format } from 'date-fns'
import { BarChart3 } from 'lucide-react'
import type { Campaign } from '@/types/newsletter'

interface CampaignOverviewTabProps {
  campaign: Campaign
}

export function CampaignOverviewTab({ campaign }: CampaignOverviewTabProps): React.JSX.Element {
  return (
    <div className="space-y-6">
      {/* Open rate chart placeholder */}
      {campaign.send_completed_at && (
        <div className="rounded-xl border border-dashed border-surface-3 bg-surface-1/30 p-8">
          <div className="flex flex-col items-center gap-2 text-center">
            <BarChart3 className="h-8 w-8 text-text-tertiary" />
            <h3 className="text-sm font-medium text-text-primary">Open rate over time</h3>
            <p className="text-xs text-text-tertiary">
              Hourly open-rate timeseries coming soon. View aggregate stats above.
            </p>
          </div>
        </div>
      )}

      {/* Summary info */}
      <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
        <h3 className="mb-4 text-sm font-medium text-text-primary">Campaign summary</h3>
        <dl className="grid gap-4 sm:grid-cols-2">
          <SummaryItem label="From" value={campaign.from_address} />
          <SummaryItem label="Subject" value={campaign.subject} />
          <SummaryItem label="Audience" value={campaign.audience_name ?? '-'} />
          <SummaryItem
            label="Sent at"
            value={
              campaign.send_completed_at
                ? format(new Date(campaign.send_completed_at), 'MMM d, yyyy HH:mm')
                : '-'
            }
          />
          <SummaryItem
            label="Total recipients"
            value={campaign.total_recipients.toLocaleString()}
          />
          <SummaryItem label="Skipped" value={campaign.total_skipped.toLocaleString()} />
        </dl>
      </div>
    </div>
  )
}

function SummaryItem({ label, value }: { label: string; value: string }): React.JSX.Element {
  return (
    <div>
      <dt className="text-xs font-medium uppercase tracking-wider text-text-secondary">{label}</dt>
      <dd className="mt-1 text-sm text-text-primary">{value}</dd>
    </div>
  )
}
